import "./App.css";
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Claim from "./pages/Claim";
import LaunchpadPage from "./pages/LaunchpadPage";
import DescriptionPage from "./pages/DescriptionPage";
import Claims from "./pages/Claims";
import Landingpage from "./pages/Landingpage";
import ApplyForIDO from "./pages/ApplyForIDO";
import Form from "./pages/Form";
import Stake from "./Components/Stake/Stake";

function App() {
  const [Connect, setConnect] = React.useState(false);
  const [DataRemove, setDataRemove] = React.useState(false);
  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <Routes>
          {/* <ScrollToTop /> */}
          <Route
            path="/"
            element={<Landingpage Connect={Connect} setConnect={setConnect} />}
          />
          <Route
            path="/launchpad"
            element={
              <LaunchpadPage Connect={Connect} setConnect={setConnect} />
            }
          />
          <Route
            path="/launchpad/:status"
            element={
              <DescriptionPage Connect={Connect} setConnect={setConnect} />
            }
          />
          <Route exact path="/form" element={<Form />} />

          {/* These are Hide Route  */}
          {/* <Route exact path="/claim" element={<Claim />} />
          <Route exact path="/claims" element={<Claims />} />*/}
          <Route
            exact
            path="/stake"
            element={<Stake Connect={Connect} setConnect={setConnect} />}
          />
          <Route
            exact
            path="/claim"
            element={<Claim Connect={Connect} setConnect={setConnect} />}
          />
          <Route
            exact
            path="/claims"
            element={<Claims Connect={Connect} setConnect={setConnect} />}
          />
        </Routes>
      </div>

      {/* <Header />
  <Launch />
  <Launchcard />  */}
    </>
  );
}

export default App;
